<template>
  <div id="podcast" style="margin-top: 20px; margin-bottom: 20px;">
    <div class="row">
      <div class="col-12">
        <a href="/the-attic-podcast" class="submit-btn2" style="z-index: 1!important">All Episodes</a>
        <div class="player-container" style="width: 100%; height: 200px; border-radius: 4px; overflow: hidden;">
          <iframe
            style="width: 100%; height: 200px; display: block;"
            frameborder="no"
            scrolling="no"
            allow="clipboard-write"
            seamless
            src="https://player.captivate.fm/show/25a785cd-8f20-4c7e-a232-b6aa1f4c3d7e/latest/"
          ></iframe>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'HomePodcast',
}
</script>

<style scoped>
.all-episodes {
  color: #fff;
  text-decoration: none;
  font-size: 13px !important;
  padding: 5px 7px;
  position: absolute;
  right: 60px;
  top: 14px;
  background: #00b4b4;
  transition: all 0.3s ease 0s;
  border: none;
  outline: none;
  border-radius: 4px;
  /* Removed duplicate border: none; — keeping the border look */
  z-index: 2; /* in case of overlap */
}
.all-episodes:hover {
  background: #429da8;
}
</style>

<style>
#podcast {
  /* Optional: if you want extra safety margin around the whole section */
}

/* This is the simplest clip for 2px shadow removal */
.player-container {
  clip-path: inset(2px);          /* clips 2px inward from all sides → hides thin outer shadow */
  -webkit-clip-path: inset(2px);  /* Safari/older WebKit support */
}

/* Optional extras if needed */
.player-container {
  background: white;              /* ensures no transparent bleed shows */
}

iframe {
  background: white !important;   /* helps blend if player has edge transparency */
  border: none !important;
}

.submit-btn2 {
  font-size: 12px;
  color: #00b4b4;
  border: 1px solid #00b4b4;
  border-radius: 4px;
  padding: 5px 12px;
  display: flex;
  align-items: center;
  gap: 2px;
  text-decoration: none;
  white-space: nowrap;
  transition: all 0.25s ease;   
  position: absolute;
  right: 60px;
  top: 14px;
  z-index: 2; /* in case of overlap */
  text-decoration: none;
}

.submit-btn2:hover {
  background: #00b4b4;
  color: #fff;
  text-decoration: none;
}
</style>



